import { gql } from '@apollo/client';
import { BASIC_CLASSROOM_FRAG } from '../../fragments';

export const GET_CHECKGRADESCLASS = gql`
  ${BASIC_CLASSROOM_FRAG}
  query SkWeb_Classroom_3($classroomId: ID!) {
    classroom(classroomId: $classroomId) {
      ...BasicClassroomFrag
      students {
        id
        name
      }
    }
  }
`;
